import { useContext } from "react";

import Box from "@/components/Box";
import Circle from "@/components/Circle";
import { InternalTextLink } from "@/components/Links";
import Text from "@/components/Text";
import RelatedResultContext from "@/contexts/RelatedResultContext";
import { ResultPresentationConsumer } from "@/contexts/ResultPresentation";
import { useOrganisationContext } from "@/contexts/organisations/OrganisationContext";
import { CMP_PATIENTS_USER_RESULT_URL, getCmpUrl } from "@/core/urls";
import Group from "@/tpo/Group";
import { ViewerContext } from "@/tpo/Viewer";

import ResultCharts from "./patientView/testResults/ResultCharts";

export function RelatedResult({ name, result, gap, py, leftFontSize, rightFontSize }) {
  const viewerContext = useContext(ViewerContext);
  const clientId = viewerContext?.userId;
  const organisationContext = useOrganisationContext();
  const organisationId = organisationContext?.organisation?.hashId;

  const relatedResultContext = useContext(RelatedResultContext);

  const href = getCmpUrl(CMP_PATIENTS_USER_RESULT_URL, {
    patientId: clientId,
    userResultId: result.id,
    organisationId
  });

  return (
    <Box display="grid" gridTemplateColumns="1fr 1fr" py={py} key={result.id}>
      {result.isHidden ? (
        <Text fontSize={leftFontSize}>{name}</Text>
      ) : relatedResultContext?.openModal ? (
        <Text
          color="anchorBlue"
          fontSize={leftFontSize}
          onClick={() => relatedResultContext.openModal(result)}
          cursor="pointer"
        >
          {name}
        </Text>
      ) : (
        <InternalTextLink href={href} fontSize={leftFontSize}>
          {name}
        </InternalTextLink>
      )}
      <ResultCharts result={result}>
        <ResultPresentationConsumer>
          {({ interpretationColor }) => {
            return (
              <Group alignItems="center" gap={10} justifyContent="end">
                <Text fontSize={rightFontSize} fontFamily="gilroyBold">
                  {result.chartConfiguration.interpretation}
                </Text>
                <Circle bg={interpretationColor} size={10} />
              </Group>
            );
          }}
        </ResultPresentationConsumer>
      </ResultCharts>
    </Box>
  );
}

RelatedResult.defaultProps = {
  leftFontSize: [16],
  rightFontSize: [16],
  py: [20]
};

export default function RelatedResults({ results, py, gap, leftFontSize, rightFontSize }) {
  return results.map(result => (
    <RelatedResult
      key={result.id}
      gap={gap}
      result={result}
      name={result.resultState.name}
      py={py}
      leftFontSize={leftFontSize}
      rightFontSize={rightFontSize}
    />
  ));
}

RelatedResults.defaultProps = {
  py: ["8px", "8px", 16],
  gap: 20
};
